/**
 * ESSE-25: Product / Lifestyle view toggle.
 *
 * Owns clicks and persistence. Which image a card shows, and which of the two
 * labels the button displays (the view currently on screen), is decided by CSS keyed
 * off `is-lifestyle-view` on <collection-component>, which the section restores inline
 * before first paint. The one thing CSS cannot do alone is the touch card — see
 * resnapSliders().
 */
(function () {
  const STORAGE_KEY = 'theme:collection-view';
  const LIFESTYLE = 'lifestyle';
  const PRODUCT = 'product';
  const CLASS_LIFESTYLE = 'is-lifestyle-view';
  const SELECTOR_BUTTON = '[data-view-switch-button]';
  const SELECTOR_COMPONENT = 'collection-component';
  const SELECTOR_SLIDER = '.product-item__image--view-switch [data-hover-slider]';

  class CollectionViewSwitch extends HTMLElement {
    constructor() {
      super();

      this.component = this.closest(SELECTOR_COMPONENT);
      this.button = this.querySelector(SELECTOR_BUTTON);
      this.clickEvent = () => this.toggle();
    }

    connectedCallback() {
      if (this.button) this.button.addEventListener('click', this.clickEvent);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.clickEvent);
    }

    currentView() {
      return this.component && this.component.classList.contains(CLASS_LIFESTYLE) ? LIFESTYLE : PRODUCT;
    }

    toggle() {
      if (!this.component) return;

      const lifestyle = this.currentView() === PRODUCT;

      this.component.classList.toggle(CLASS_LIFESTYLE, lifestyle);
      this.resnapSliders();

      // Safari in private mode throws on write; the class swap must survive it.
      try {
        if (lifestyle) {
          window.sessionStorage.setItem(STORAGE_KEY, LIFESTYLE);
        } else {
          window.sessionStorage.removeItem(STORAGE_KEY);
        }
      } catch (e) {}
    }

    /**
     * Touch only. There the card IS the swipe slider, and the view is expressed by
     * `order: -1` on the lifestyle slide. Reordering alone is invisible: a
     * scroll-snap container re-snaps to the element that was already snapped, so
     * the card scrolls to follow its old image and the customer sees no change.
     * Reset every slider to its first slide so the reorder actually lands.
     *
     * Assigning scrollLeft fires `scroll`, which is what HoverImages.handleScroll
     * listens to for the `--slider-index` progress bar, so that stays in sync.
     */
    resnapSliders() {
      if (!document.documentElement.classList.contains('supports-touch')) return;

      this.component.querySelectorAll(SELECTOR_SLIDER).forEach((slider) => {
        slider.scrollLeft = 0;
      });
    }
  }

  if (!customElements.get('collection-view-switch')) {
    customElements.define('collection-view-switch', CollectionViewSwitch);
  }
})();
